import { useMemo } from "react";

/**
 * CSS-driven cinematic gold dust layer for the hero.
 * Avoids react-three-fiber to stay compatible with the build's JSX instrumentation,
 * while still delivering a premium floating-particle ambience.
 */
export default function HeroParticles() {
  const dots = useMemo(() => {
    const arr = [];
    for (let i = 0; i < 70; i++) {
      const size = Math.random() * 3 + 1;
      arr.push({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size,
        delay: -Math.random() * 12,
        duration: 9 + Math.random() * 14,
        drift: (Math.random() - 0.5) * 40,
        opacity: 0.35 + Math.random() * 0.55,
        gold: Math.random() > 0.35,
      });
    }
    return arr;
  }, []);

  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none overflow-hidden [mask-image:linear-gradient(to_bottom,black_55%,transparent_100%)]"
    >
      <style>{`
        @keyframes mdp-drift {
          0%   { transform: translate3d(0, 0, 0) scale(1); opacity: var(--o, 0.6); }
          50%  { transform: translate3d(var(--dx, 0px), -28vh, 0) scale(1.15); opacity: 1; }
          100% { transform: translate3d(0, -55vh, 0) scale(0.6); opacity: 0; }
        }
        .mdp-particle {
          position: absolute;
          border-radius: 9999px;
          will-change: transform, opacity;
          animation-name: mdp-drift;
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
          filter: blur(0.5px);
        }
      `}</style>
      {dots.map((d) => (
        <span
          key={d.id}
          className="mdp-particle"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            backgroundColor: d.gold ? "#E6C555" : "#FDFBF7",
            boxShadow: d.gold
              ? "0 0 8px rgba(212,175,55,0.65)"
              : "0 0 6px rgba(255,255,255,0.4)",
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
            opacity: d.opacity,
            ["--dx"]: `${d.drift}px`,
            ["--o"]: d.opacity,
          }}
        />
      ))}
    </div>
  );
}
